module.exports = __webpack_public_path__ + "img/hsa-store-logo-purple.d5a817e7.png";